var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "bet-board-actions",
      class: {
        "bet-board-actions--fancy": _vm.fancy,
        "bet-board-actions--pin-bottom": _vm.fancy && _vm.pinBottom,
      },
    },
    [
      _c(
        "button",
        {
          staticClass: "bet-board-actions__undo",
          attrs: { type: "button", disabled: !_vm.canUndo },
          on: {
            mousedown: function ($event) {
              return _vm.onUndoPressStart("mousedown")
            },
            mouseup: function ($event) {
              return _vm.onUndoPressEnd("mouseup")
            },
            mouseleave: _vm.onUndoPressCancel,
            touchstart: function ($event) {
              $event.preventDefault()
              return _vm.onUndoPressStart("touchstart")
            },
            touchend: function ($event) {
              return _vm.onUndoPressEnd("touchend")
            },
            touchcancel: _vm.onUndoPressCancel,
          },
        },
        [
          _c("img", {
            attrs: { src: require("@/assets/svg/btns/undo.svg"), alt: "" },
          }),
          _c("small", [_vm._v(_vm._s(_vm.$t("Undo")))]),
        ]
      ),
      _c("BetChipSelector", {
        staticClass: "bet-board-actions__chips",
        attrs: {
          chips: _vm.chips,
          "active-chip": _vm.activeChip,
          "chip-colors": _vm.chipColors,
          fancy: _vm.fancy,
          custom: _vm.custom,
          "arena-id": _vm.arenaId,
        },
        on: {
          "select-chip": function ($event) {
            return _vm.$emit("select-chip", $event)
          },
        },
      }),
      !_vm.fancy
        ? _c(
            "button",
            {
              staticClass: "bet-board-actions__clear",
              attrs: { type: "button", disabled: !_vm.hasBets },
              on: {
                click: function ($event) {
                  return _vm.$emit("clear")
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("Clear")) + " ")]
          )
        : _vm._e(),
      _c(
        "button",
        {
          staticClass: "bet-board-actions__submit",
          attrs: {
            type: "button",
            disabled:
              _vm.isSubmitting ||
              _vm.isRolling ||
              _vm.bettingDisabled ||
              !_vm.hasBets,
          },
          on: {
            click: function ($event) {
              return _vm.$emit("submit")
            },
          },
        },
        [
          _vm._v(
            " " +
              _vm._s(_vm.isRolling ? _vm.$t("Rolling") : _vm.$t("Bet")) +
              " "
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }